import { render, staticRenderFns } from "./IBreadcrumbs.vue?vue&type=template&id=b7a308a8&scoped=true&functional=true&"
import script from "./IBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./IBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./IBreadcrumbs.vue?vue&type=style&index=0&id=b7a308a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b7a308a8",
  null
  
)

export default component.exports